import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import styles from '../../../../styles/DashboardV2.module.css';

interface ActionRequiredWidgetProps {
    expiringCount: number;
    expiredCount: number;
    incompleteListings: number;
    draftListings: number;
    loading?: boolean;
}

const ActionRequiredWidget: React.FC<ActionRequiredWidgetProps> = ({
    expiringCount,
    expiredCount,
    incompleteListings,
    draftListings,
    loading,
}) => {
    const totalActions = expiringCount + expiredCount + incompleteListings + draftListings;

    const items = [
        {
            icon: '❌',
            iconClass: styles.actionIconRed,
            title: 'Expired Documents',
            subtitle: 'Require immediate renewal',
            count: expiredCount,
            countClass: styles.actionCountRed,
        },
        {
            icon: '⚠️',
            iconClass: styles.actionIconAmber,
            title: 'Documents Expiring Soon',
            subtitle: 'Expiring within 30 days',
            count: expiringCount,
            countClass: styles.actionCountAmber,
        },
        {
            icon: '🏠',
            iconClass: styles.actionIconAmber,
            title: 'Incomplete Listings',
            subtitle: 'Missing required information',
            count: incompleteListings,
            countClass: styles.actionCountAmber,
        },
        {
            icon: '📝',
            iconClass: styles.actionIconBlue,
            title: 'Draft Listings',
            subtitle: 'Ready to be published',
            count: draftListings,
            countClass: styles.actionCountBlue,
        },
    ].filter(item => item.count > 0);

    return (
        <DashboardCard
            title="Needs Attention"
            loading={loading}
        >
            {totalActions === 0 ? (
                <div className={styles.actionAllClear}>
                    <span style={{ fontSize: '2rem' }}>✅</span>
                    <span>All clear — no actions required</span>
                </div>
            ) : (
                <div className={styles.actionList}>
                    {items.map((item, i) => (
                        <div key={i} className={styles.actionItem}>
                            <div className={`${styles.actionItemIcon} ${item.iconClass}`}>
                                {item.icon}
                            </div>
                            <div className={styles.actionItemContent}>
                                <div className={styles.actionItemTitle}>{item.title}</div>
                                <div className={styles.actionItemSubtitle}>{item.subtitle}</div>
                            </div>
                            <div className={`${styles.actionItemCount} ${item.countClass}`}>
                                {item.count}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default ActionRequiredWidget;
